import L from 'leaflet';

/**
 * Manages named Leaflet feature groups so other map modules
 * can add/remove markers without knowing about the map instance directly.
 */
export class MapLayers {
  constructor(map) {
    this.map = map;
    this.layers = {};
  }

  /** Get (or lazily create) a named layer group */
  getLayer(name) {
    if (!this.layers[name]) {
      this.layers[name] = L.layerGroup().addTo(this.map);
    }
    return this.layers[name];
  }

  /** Clear all markers from a named layer */
  clearLayer(name) {
    if (this.layers[name]) this.layers[name].clearLayers();
  }
}
